<template>
  <div>
    <div class="wrapper">
        <div class="inner">
          <a href="https://www.wenhua.com.cn/" target="_blank" class="webstock">文华财经官网</a>
          <p v-html="'© 版权所有&nbsp;&nbsp;&nbsp;上海文华财经资讯股份有限公司&nbsp;&nbsp;&nbsp;ICP证号：沪B2-20110035'"></p>
        </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Foot',
  components: {
    
  }
}
</script>

<style scoped>
  .wrapper{
      width: 100%;
      height: 72px;
      text-align: center;
  }
  .inner {
      width: 100%;
      background: rgb(0,0,0,0.7);
      height: 100%;
      margin: 0 auto;
      box-sizing: border-box;
      padding-top: 7px;
      position: relative;
      line-height: 26px;
  }
  
  .inner a:hover {
      text-decoration: underline;
  }
  .inner p {
      margin: 0 0 5px 0;
      color: rgb(151, 151, 153);
  }
  .webstock{
    color: #70A9FF;
    position: relative;
  }
  .webstock::before{
    content: "";
    display: block;
    width: 14px;
    height: 13px;
    background: url(../assets/image/hp.png) no-repeat center;
    position: absolute;
    top: 2px;
    left: -22px;
  }
</style>